import { useTranslation } from "react-i18next";
import Item from "./Item";
import Title from "./Title";

export default function Formations() {
	const { t } = useTranslation();

	return (
		<div id="cursus" className="flex-1 max-sm:mt-24">
			<Title>{t("formations.title")}</Title>

			<div className="mx-auto w-3/4 max-lg: flex flex-col">
				<Item
					id="master"
					title={t("master")}
					date="2022 - 2024"
					where={t("perrin") + " - Lens"}
					image="imgs/fjp2.jpg"
					logo="imgs/artois.png"
					skills={
						t("formations.1", { returnObjects: true }) as string[]
					}
				></Item>
				<Item
					id="licence"
					title={t("licence")}
					date="2021 - 2022"
					where={t("perrin") + " - Lens"}
					image="imgs/fjp.jpg"
					logo="imgs/artois.png"
					skills={
						t("formations.2", { returnObjects: true }) as string[]
					}
				></Item>
				<Item
					id="dut"
					title={t("dut")}
					date="2019 - 2021"
					where={t("iut")}
					image="imgs/idl.jpg"
					logo="imgs/iut-i.png"
					skills={
						t("formations.3", { returnObjects: true }) as string[]
					}
				></Item>
				<Item
					id="bac"
					title={t("bac")}
					date="2017 - 2019"
					where={t("carnot") + " - Bruay-la-Buissière"}
					image="imgs/lc.jpg"
					logo="imgs/carnot2-i.png"
					skills={
						t("formations.4", { returnObjects: true }) as string[]
					}
				></Item>
			</div>
		</div>
	);
}
